import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {

  connect() {
    this.buildSelect(this.element);
  }

  buildSelect(element) {
    this.select = new TomSelect(element, {
        persist: false,
        render: {
          no_results: function(data, escape) {
            return '<div class="no-results text-center">Resultado não encontrado</div>';
          } 
        }
      }
    );
  }

}